import {CommonResponse, BaseRequestParams, GetParamsType, GetSingleParamsType, instance} from "./API"
import {AxiosResponse} from "axios"
import {filterToString} from "../helps/filterToString"
import {PSLeakDeviceFilterQuery} from "../store/psLeakDeviceReducer"
import {PSLeakDeviceResponse, PSLeakDevicesResponse} from "../models/response"
import {ProblemsResponse} from "../models/response/ProblemsResponse"

export const psLeakDeviceApi = {
    getDevices(params?: GetParamsType & PSLeakDeviceFilterQuery): Promise<CommonResponse<PSLeakDevicesResponse>> {
        const paramsString = filterToString(params)
        return instance.get(`PSLeakDevice${paramsString}`, {signal: params?.controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    getDevice(params: GetSingleParamsType): Promise<CommonResponse<PSLeakDeviceResponse>> {
        const {id, controller} = params
        return instance.get(`PSLeakDevice/${id}`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    createDevice(form: CreateDeviceType): Promise<CommonResponse<PSLeakDeviceResponse>> {
        const {controller, ...rest} = form
        return instance.post(`PSLeakDevice`, {...rest}, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    changeDevice(form: ChangeDeviceType): Promise<CommonResponse<PSLeakDeviceResponse>> {
        const {id, controller, ...rest} = form
        return instance.put(`PSLeakDevice/${id}`, {...rest}, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    updateSettingsDevice(form: UpdateSettingsDeviceType): Promise<CommonResponse<PSLeakDeviceResponse>> {
        const {id, controller, ...rest} = form
        return instance.put(`PSLeakDevice/settings/${id}`, {...rest}, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    deleteDevice(id: number): Promise<CommonResponse<any>> {
        return instance.delete(`PSLeakDevice/${id}`).then((res: AxiosResponse) => res.data)
    },
    removeToken(params: RemoveDeviceTokenType): Promise<CommonResponse<PSLeakDeviceResponse>> {
        const {deviceId, controller} = params
        return instance.get(`PSLeakDevice/removeToken/${deviceId}`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    armingDevice(params: ArmingDeviceType): Promise<CommonResponse<boolean>> {
        const {deviceId, status, controller} = params
        return instance.get(`PSLeakDevice/setOnGuard/${deviceId}?status=${status}`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    updateDeviceFirmware(params: UpdateDeviceFirmwareType): Promise<CommonResponse<boolean>> {
        const {deviceId, controller} = params
        return instance.get(`PSLeakDevice/updateFirmware/${deviceId}`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    rebootDevice(params: RebootDeviceType): Promise<CommonResponse<boolean>> {
        const {deviceId, controller} = params
        return instance.get(`PSLeakDevice/reboot/${deviceId}`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    getProblems(params: BaseRequestParams): Promise<CommonResponse<Array<ProblemsResponse>>> {
        const {controller} = params
        return instance.get(`PSLeakDevice/problems`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    solveMemoryError(params: GetSingleParamsType): Promise<CommonResponse<Array<ProblemsResponse>>> {
        const {id, controller} = params
        return instance.get(`PSLeakDevice/solveMemoryError/${id}`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    getDeviceInfo(params: GetSingleParamsType): Promise<CommonResponse<string>> {
        const {id, controller} = params
        return instance.get(`PSLeakDevice/deviceInfo/${id}`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
}

export type CreateDeviceType = {
    name: string
    comment: string
    idObject: number
    active: boolean
    uin: string
    disableLocalData: boolean
    macAddress?: string | null
    ipAddress?: string | null
    port?: number | null
} & BaseRequestParams

export type ChangeDeviceType = {
    id: number
    name: string
    comment: string
    idObject: number
    active: boolean
    disableLocalData: boolean
    ipAddress?: string | null
    port?: number | null
} & BaseRequestParams

export type UpdateSettingsDeviceType = {
    id: number
    attributesServer: string
    saveAsLocalAttributes?: boolean
} & BaseRequestParams

export type ArmingDeviceType = {
    deviceId: number
    status: boolean
} & BaseRequestParams

export type UpdateDeviceFirmwareType = {
    deviceId: number
} & BaseRequestParams

export type RebootDeviceType = {
    deviceId: number
} & BaseRequestParams

export type RemoveDeviceTokenType = {
    deviceId: number
} & BaseRequestParams